module.exports = __webpack_public_path__ + "static/media/pov_highlight_face_GreatIcosahedron.01a4de90.png";